export const priceMatrixFileType = {
  'text/csv': ['.csv'],
  'file/xls': ['.xls'],
  'file/xlsx': ['.xlsx'],
};

export const numericalInputFields = ['number'];

export const allowedTypesMatrixAxis = ['list', 'number', 'radio'];
